/** Whether an address is Marvin's review in a window of its own (`composer/draftRoutes.ts`'s
 * `reviewWindowPath`): the app draws no chrome around it. Kept here, free of imports, so the
 * startup shell can read it without loading the composer's modules. */
export const isReviewWindowPath = (pathname: string) =>
    /^\/documents\/[^/]+\/[^/]+\/marvin\/window\/?$/.test(pathname);

/** Select a project: every project the person can open, outside any project, with a bar of its
 *  own (`screens/Projects`). */
export const PROJECTS_PATH = "/projects";

/** Usage's printable report: paper pages with nothing of the app around them (no import of
 *  `shared/constants` here, for the startup shell). */
const USAGE_REPORT = "/usage/report";

export function isStandaloneAppRoute(pathname: string): boolean {
    return (
        pathname === PROJECTS_PATH ||
        pathname === USAGE_REPORT ||
        pathname.startsWith("/table-edit/") ||
        pathname.startsWith("/oauth/") ||
        pathname.startsWith("/embed-auth") ||
        isReviewWindowPath(pathname)
    );
}

/** Shared by startup chrome and the loaded app; needs no router or tenant data. */
export function resolveAppChrome({
    pathname,
    redesigned,
    tablet,
    inIframe,
}: {
    pathname: string;
    redesigned: boolean;
    tablet: boolean;
    inIframe: boolean;
}): "workspace" | "tablet" | "embed" | "header" | "none" {
    if (tablet) return "tablet";
    if (isStandaloneAppRoute(pathname)) return "none";
    if (inIframe && redesigned) return "embed";
    // Sign-in draws its own page (the wordmark, no bar) in either design.
    if (pathname === "/authenticate") return "none";
    return redesigned ? "workspace" : "header";
}
